import { useCallback } from 'react';
import { api } from '../utils/apiHandler';
import type { AxiosResponse } from 'axios';
import type { GetActivitiesParams, GetActivitiesResponse } from './types/activitiesTypes';

const ACTIVITIES_PATH = '/activities';

const useActivitiesResource = () => {
  // Fetch activities (paginated, filterable)
  const getActivities = useCallback(async (params?: GetActivitiesParams): Promise<GetActivitiesResponse> => {
    const response: AxiosResponse<GetActivitiesResponse> = await api.request<undefined, AxiosResponse<GetActivitiesResponse>>({
      method: 'GET',
      url: ACTIVITIES_PATH,
      params
    });
    return response.data;
  }, []);

  return { getActivities };
};

export default useActivitiesResource;
